
import {
  defineComponent, PropType, ref, computed,
} from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'primevue/button';
import LoopConfigurationModal from '@/components/template-builder/modals/LoopConfigurationModal.vue';
import type { LoopConfiguration } from '@/types/loop-configuration';
import { FieldConfig, ParserFieldObject } from '@/types';

export default defineComponent({
  name: 'FormFieldLoopConfiguration',

  components: {
    Button,
    LoopConfigurationModal,
  },

  props: {
    configs: {
      type: Object as PropType<FieldConfig>,
      required: true,
    },

    parserValues: {
      type: Object as PropType<ParserFieldObject>,
      required: true,
    },
  },

  emits: ['on-change-properties'],

  setup(props, { emit }) {
    const { t } = useI18n();

    const showDialog = ref(false);

    const property = computed(() => props.parserValues.properties?.[0]);
    const modelValue = computed(() => property.value?.value as LoopConfiguration | null);

    const isConfigured = computed(() => modelValue.value?.enabled
      && modelValue.value?.collection
      && modelValue.value?.iterator);

    const currentLoopValue = computed(() => {
      if (modelValue.value?.enabled) {
        return modelValue.value;
      }
      return null;
    });

    const openConfiguration = () => {
      showDialog.value = true;
    };

    const handleLoopSave = (config: LoopConfiguration) => {
      if (property.value) {
        const updatedProperty = { ...property.value, value: config };

        emit('on-change-properties', {
          selector: props.parserValues.selector,
          properties: [updatedProperty],
        });
      }
      showDialog.value = false;
    };

    const deleteConfiguration = () => {
      if (property.value) {
        const updatedProperty = { ...property.value, value: null };

        emit('on-change-properties', {
          selector: props.parserValues.selector,
          properties: [updatedProperty],
        });
      }
    };

    return {
      t,
      showDialog,
      isConfigured,
      modelValue,
      currentLoopValue,
      openConfiguration,
      handleLoopSave,
      deleteConfiguration,
    };
  },
});
